"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BROWSER_SUPPORT_SEEN_COOKIE_EXPIRY_TIME = void 0;
const react_1 = __importStar(require("react"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faTimes_1 = require("@fortawesome/pro-light-svg-icons/faTimes");
const deviceUtils_1 = require("../../utils/deviceUtils");
const Button_1 = __importDefault(require("../Button"));
const Link_1 = __importDefault(require("../Link"));
const styles = require('./UnsupportedBrowserBanner.module.scss');
const browserSupportCookieName = 'browser-support-seen';
exports.BROWSER_SUPPORT_SEEN_COOKIE_EXPIRY_TIME = 31536000;
const setHasSeenBannerCookie = () => js_cookie_1.default.set(browserSupportCookieName, 'true', {
    expires: exports.BROWSER_SUPPORT_SEEN_COOKIE_EXPIRY_TIME,
});
const UnsupportedBrowserBanner = ({ cookies, browser }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(true);
    const isUnsupportedBrowser = (0, deviceUtils_1.getIsUnsupportedBrowser)(browser) === deviceUtils_1.BrowserSupportType.ShowBanner;
    const hasSeenBanner = (cookies && cookies[browserSupportCookieName]) || false;
    if (!isOpen || !isUnsupportedBrowser || hasSeenBanner) {
        return null;
    }
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement("span", null,
            "Your web browser is not supported. ",
            react_1.default.createElement(Link_1.default, { href: "/support" }, "Find out more here")),
        react_1.default.createElement(Button_1.default, { appearance: "solid", className: styles.closeButton, icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faTimes_1.faTimes, className: styles.closeIcon }), iconPosition: "left", isIconVisible: true, isTextVisible: false, noDropShadow: true, onClick: () => {
                setIsOpen(false);
                setHasSeenBannerCookie();
            } }, "Close")));
};
exports.default = UnsupportedBrowserBanner;
//# sourceMappingURL=UnsupportedBrowserBanner.js.map